<template>
  <div 
    :style="containerStyle"
    class="d-flex flex-column align-center justify-center"
  >
    <svg 
      xmlns="http://www.w3.org/2000/svg" :viewBox="viewBox"
      style="position: absolute; top: 0px; left: 0px;"
    >
      <path style="fill:none; stroke: #C4C4C4; stroke-width:12" :d="basePath"/>
      <path style="fill:none; stroke:#329331; stroke-width:12" :d="path1"/>
    </svg>

    <div>
      <slot>aaa</slot>
    </div>  
  </div>
</template>

<script>

const radians = (degrees) => degrees / 180.0 * Math.PI
const toCartesian = (angle, radius) => {
  let x = radius * Math.cos(angle)
  let y = radius * Math.sin(angle)

  return {x, y}
}

const coords = (pos) => `${pos.x.toFixed(3)},${pos.y.toFixed(3)}`

export default {
  name: 'RewardProgress',

  props: {
    completed: {
      type: Number,
      required: true,
    },

    size: {
      type: Number,
      default: 125,
    },
  },

  data: () => ({
    strokeWidth: 12.0,
    startAngle: radians(135),
    endAngle: radians(45),
  }),

  computed: {
    radius() { return this.size / 2.0 },
    centerRadius()  { return this.radius - this.strokeWidth/2 },

    range() {
      if (this.startAngle > this.endAngle) {
        return 2 * Math.PI - (this.startAngle - this.endAngle)
      } else {
        return this.startAngle - this.endAngle + 2 * Math.PI
      }
    },

    midAngle() { return (this.startAngle + this.range * this.completed) % (2 * Math.PI) },

    start() { return toCartesian(this.startAngle, this.centerRadius) },
    mid()   { return toCartesian(this.midAngle, this.centerRadius) },
    end()   { return toCartesian(this.endAngle, this.centerRadius) },

    minX() { return -this.size/2 },
    maxX() { return this.size/2 },

    minY() { 
      return Math.min(
        toCartesian(this.startAngle, this.radius).y, 
        toCartesian(- Math.PI / 2, this.radius).y, 
        toCartesian(this.endAngle, this.radius).y
      ) 
    },
    maxY() { 
      return Math.max(
        toCartesian(this.startAngle, this.radius).y, 
        toCartesian(- Math.PI / 2, this.radius).y, 
        toCartesian(this.endAngle, this.radius).y
      ) 
    },
    viewWidth() { return this.size },
    viewHeight() { return this.maxY - this.minY },

    viewBox() { return `${ this.minX } ${ this.minY } ${ this.viewWidth } ${ this.viewHeight }`},

    basePath() {
      let p = `M ${ coords(this.start) }\n`
      
      p += `A ${ this.centerRadius }, ${ this.centerRadius } 0,1,1 ${ coords(this.end) }\n`

      return p
    },

    path1() {
      let p = `M ${ coords(this.start) }`

      if (this.completed * this.range > Math.PI) {
        p += ` A ${ this.centerRadius }, ${ this.centerRadius } 0,1,1 ${ coords(this.mid) }`
      } else {
        p += ` A ${ this.centerRadius }, ${ this.centerRadius } 0,0,1 ${ coords(this.mid) }`
      }

      return p
    },

    containerStyle() {
      return  {
        'width': `${ this.size }px`,
        'height': `${ this.viewHeight }px`,
        'max-width': '${ this.size }px',
        'max-height': `${ this.viewHeight }px`,
        position: 'relative'
      }
    },
  },
}
</script>
